import { axiosInstance } from '@App/providers';

const url = window._env_.MS_D2C_BASE_URL as string;

export const signUp = async (username: string) => {
    return await axiosInstance.post(`${url}/api/user/create`, {
        username,
        userAttributes: [
            { name: 'email', value: username },
            { name: 'custom:isD2CUser', value: 'true' },
        ],
    });
};

export const requestOtp = async (email: string) => {
    return await axiosInstance.post(`${url}/api/auth/token/otp`, {
        email,
    });
};

export const confirmOtp = async (
    email: string,
    session: string,
    otp: string,
) => {
    return await axiosInstance.post(`${url}/api/auth/token/otp/confirm`, {
        email,
        session,
        otp,
    });
};

export const refreshTokens = async (refreshToken: string) => {
    return await axiosInstance.post(`${url}/api/auth/refresh-token`, {
        refreshToken,
    });
};

export const logout = async (accessToken: string, refreshToken: string) => {
    return await axiosInstance.post(`${url}/api/auth/logout`, {
        accessToken,
        refreshToken,
    });
};
